// extracted by mini-css-extract-plugin
module.exports = {"container":"_3uvgfwBWaWQqFyLab9Dtip","image":"hS9SabcUKdHLsU7xUWYeA","title":"_3zsZZ1G9oclG4rKZNszc97","logo":"_1EDR5Wb9Y0TBlQji0Ya33U"};